import usePromoCode from 'hooks/usePromoCode/usePromoCode'

export default usePromoCode
